import React, { ReactNode } from 'react';
import AppConfig from '~/utils/appconfig';

export enum Features {
    ADAPT_WORKFLOW = 'adapt-workflow',
    DOSE_WORKFLOW = 'dose-workflow',
    CONTOUR_WORKFLOW = 'contour-workflow',
    DATA_UPLOAD = 'data-upload',
    SEG_VERIFY = 'verify',
    IMAGE_TRANSLATION_WORKFLOW = 'image-translation-workflow',
    OPTIMIZATION_OBJECTIVES = 'optimization-objectives',
}

interface FeatureToggleProps {
    feature: Features;
    fallback?: ReactNode;
    children: ReactNode;
}

const FeatureToggle: React.FC<FeatureToggleProps> = ({
    feature,
    fallback = null,
    children,
}) => {
    const isEnabled = AppConfig.isFeatureEnabled(feature);
    return isEnabled ? <>{children}</> : <>{fallback}</>;
};

export default FeatureToggle;
